// src/components/Clamping.js
import React from 'react';
import clampingImg from '../../../imgs/Clamping.webp';
import './Clamping.css';

const Clamping = () => {
  return (
    <div className="clamping-container">
      <div className="clamping-image"data-aos="flip-down">
        <img src={clampingImg} alt="Clamping System"  />
      </div>
      <div className="clamping-text">
        <h2>CLAMPING SYSTEM (Center-Press Toggle)</h2>
        <ul>
          <li>Improve Stability In Molding</li>
          <li>Reduce Platen Damage</li>
          <li>Higher Speed And Stable Platen Movement</li>
        </ul>
        <p>
          Center-press toggle system designed to apply equal force on mold during clamping
          and preventing platen’s damage.
        </p>
        <p>
          New design of the clamping structure, ensures the rigid mold platen enhancement
          increasing more than 20%. Anti-tilt side design of the foot ensures the opening
          and closing of smooth high-speed. European ejector design, enhances the adaptability
          of the mold.
        </p>
        <strong>Difference Of Center-Press Toggle?</strong>
      </div>
    </div>
  );
};

export default Clamping;
